import React from "react"
import PageWrapper from "Pages/@PageWrapper"
import { ADMIN_ROUTES } from "@constants"
import { Grid } from "@mui/material"
import ProvidersSuppliersMappingTable from "Pages/Admin/ProvidersSuppliersMapping/Table"
import ProvidersSuppliersMappingModal from "Pages/Admin/ProvidersSuppliersMapping/Modal"

export default function ProvidersSuppliersMappingAdminPage() {

	return <PageWrapper
		head={`DS Rentacar | ${ADMIN_ROUTES.TITLE}`}
		title={ADMIN_ROUTES.TITLE}
		subtitle={ADMIN_ROUTES.PROVIDERS_WEB_SUPPLIERS_MAPPING_SUBTITLE}
		isEmpty={false}
	>
		<Grid container spacing={2}>
			<Grid item xs={6}>
				<ProvidersSuppliersMappingTable/>
			</Grid>
			<Grid item xs={6}>
				<ProvidersSuppliersMappingTable type="web-suppliers"/>
			</Grid>
			<Grid item xs={12}>
				<ProvidersSuppliersMappingModal/>
			</Grid>
		</Grid>
	</PageWrapper>
}